// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1D3ti","row":"styles_row__2NcRS"};